import React from 'react';
import PropTypes from 'prop-types';
import PlayerMatchup from './PlayerMatchupPattern';
import { useSelector } from 'react-redux';
import { getContextData } from '@gameday/utils/selectors/getContextData';
import buildPlayerUrl from '@gameday/utils/buildPlayerUrl';

const PlayerMatchupWrapper = (props) => {
    const { playerId, language, linkProps } = props;

    const getPlayerContextData = useSelector(getContextData);
    const { headshotType, disablePlayerLinks, playerPageContext } = getPlayerContextData(props.playerId);
    let clonedLinkProps;
    const hasLink = !disablePlayerLinks && props?.linkProps;

    if (hasLink) {
        const url = buildPlayerUrl({ nameSlug: playerId, language, playerPageContext });
        clonedLinkProps = { ...linkProps };
        clonedLinkProps.url = url;
        clonedLinkProps.dataAttr = {
            'data-playerid': playerId,
            'data-url': url
        };
        clonedLinkProps.target = '_blank';
    }
    return <PlayerMatchup {...props} headshotType={headshotType} linkProps={hasLink ? clonedLinkProps : null} headshotRatio='1:1' />;
};

PlayerMatchupWrapper.propTypes = {
    linkProps: PropTypes.object,
    playerId: PropTypes.number,
    language: PropTypes.string
};
export default PlayerMatchupWrapper;
